// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__nPlOP","title":"Images90_title__3E7I3","images":"Images90_images__dCJBu"};